import * as React from 'react';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { useAdminAccountQuery } from '../../../queries/Admin/Account/useAdminAccountQuery';
import * as AdminViewModels from '../../../viewmodels/AdminViewModels';

export function useAccountDetailsV2Data(accountId: string) {
	const userSession = useAdminUserSession();

	const accountQuery = useAdminAccountQuery({ accountId });
	const account = accountQuery.data;

	const accountOperations = React.useMemo(
		() => new AdminViewModels.AccountOperationsViewModel(userSession, { id: accountId }),
		[userSession, accountId]
	);

	const impersonationContextVM = React.useMemo(() => new AdminViewModels.ImpersonationContextViewModel(), []);

	React.useEffect(() => {
		if (account) {
			impersonationContextVM.update({ account });
			accountOperations.updateAccountData(account);
		}
	}, [account, accountOperations, impersonationContextVM]);

	return {
		account,
		accountOperations,
		impersonationContextVM,
		userSession,
		isLoading: accountQuery.isLoading,
	};
}
